import { UUID } from "crypto";
import { RefinDTO } from "./refinDTO";
import { CompraDividaDTO } from "./compraDividaDTO";

export class ResultadoSimulacaoPropostaDTO {
  public promotora!: string;
  public pontoVenda!: string;
  public empregador!: string;
  public financiamento!: string;
  public produto!: string;
  public tipoProposta!: string;
  public valorRMC!: number;
  public valorRMCUtilizado!: number;
  public valorParcela!: number;
  public valorSolicitado!: number;
  public prazo!: number;
  public contratosRefin!: Array<RefinDTO>;
  public contratosCompra!: Array<CompraDividaDTO>;

  
  public valorLimite!: number;
  public limiteCompra!: number;
  public valorMaximoCompra!: number;
  public limiteSaque!: number;
  public limiteSaqueDisplay!: number; 


 
  public valorIof!: number;
  public valorPrincipal!: number;
  public valorRefin!: number;
  public valorCompra!: number;
  public valorLiquido!: number;
  public valorBruto!: number;
  public taxaClAM!: number;
  public taxaClAA!: number;
  public taxaCetAM!: number;
  public taxaCetAA!: number;
  public primeiroVencimento!: Date;
  public ultimoVencimento!: Date;

  public cpfCliente!: string;
  public nomeCliente!: string;
  public matriculaCliente!: string;
  public dtNascimentoCliente!: Date;

  public idLogSimulacao!: UUID;
  public orgao!: string;
}